// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"B5-z","colorTextValue":"C5-z","swatches":"D5-z","collapseLink":"E5-z","isCollapsed":"F5-z","dropdown":"G5-z","disabled":"H5-z"};